module.exports = __webpack_public_path__ + "img/can4.8d4d62d6.png";